import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=b23bce1a&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b23bce1a')) {
      api.createRecord('b23bce1a', component.options)
    } else {
      api.reload('b23bce1a', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=b23bce1a&", function () {
      api.rerender('b23bce1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8skhky5Bv0sMw/JS/offershelp.vue"
export default component.exports